import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, onSnapshot, doc, updateDoc, arrayUnion } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setLoading(false);
      return;
    }

    const fetchNotifications = async () => {
      try {
        // جلب إشعارات المستخدم
        const userDoc = await doc(db, 'users', user.uid).get();
        const dismissed = userDoc.data()?.dismissed_notifications || [];
        
        // جلب الإشعارات النشطة
        const q = query(
          collection(db, 'notifications'),
          where('is_active', '==', true)
        );
        
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const activeNotifs = snapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .filter(notif => !dismissed.includes(notif.id))
            .sort((a, b) => (b.created_at?.seconds || 0) - (a.created_at?.seconds || 0));
          
          setNotifications(activeNotifs);
          setLoading(false);
        });

        return () => unsubscribe();
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  const dismissNotification = async (notifId) => {
    try {
      const user = auth.currentUser;
      if (!user) return;
      
      await updateDoc(doc(db, 'users', user.uid), {
        dismissed_notifications: arrayUnion(notifId)
      });
      
      // إزالة الإشعار من القائمة المحلية
      setNotifications(prev => prev.filter(notif => notif.id !== notifId));
    } catch (error) {
      console.error("Error dismissing notification:", error);
    }
  };

  if (loading) {
    return <div style={{ padding: '20px' }}>Loading notifications...</div>;
  }

  return (
    <div style={{ padding: '20px', direction: 'ltr', fontFamily: 'Arial' }}>
      <h1 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        📢 إشعاراتك من TradeAH
      </h1>
      
      {notifications.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px', color: '#cbd5e1' }}>🔔</div>
          <p>لا توجد إشعارات حالياً</p>
          <p style={{ color: '#64748b', fontSize: '14px', marginTop: '8px' }}>
            سيتم إرسال إشعارات مهمة عند توفرها
          </p>
        </div>
      ) : (
        <div style={{ 
          display: 'grid', 
          gap: '16px'
        }}>
          {notifications.map(notif => (
            <div 
              key={notif.id}
              style={{
                backgroundColor: '#f0fdf4',
                border: '1px solid #bbf7d0',
                borderRadius: '16px',
                padding: '20px',
                position: 'relative'
              }}
            >
              <div style={{ 
                position: 'absolute', 
                top: '12px', 
                left: '12px', 
                cursor: 'pointer',
                fontSize: '20px'
              }}
                onClick={() => dismissNotification(notif.id)}
              >
                ×
              </div>
              
              {notif.title && (
                <h3 style={{ 
                  margin: '0 28px 12px 0', 
                  color: '#065f46', 
                  fontWeight: 'bold',
                  fontSize: '18px'
                }}>
                  {notif.title}
                </h3>
              )}
              
              <p style={{ 
                margin: 0, 
                color: '#065f46',
                fontSize: '15px',
                lineHeight: '1.6'
              }}>
                {notif.message}
              </p>
              
              {notif.created_at && (
                <div style={{ 
                  marginTop: '12px', 
                  fontSize: '13px', 
                  color: '#166534',
                  textAlign: 'left'
                }}>
                  {new Date(notif.created_at.seconds * 1000).toLocaleDateString('ar-EG')}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}